require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.typed.uint32-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

!function (e) {
  if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).numbro = e();
  }
}(function () {
  return function a(o, u, c) {
    function s(t, e) {
      if (!u[t]) {
        if (!o[t]) {
          var r = "function" == typeof require && require;
          if (!e && r) return r(t, !0);
          if (l) return l(t, !0);
          var n = new Error("Cannot find module '" + t + "'");
          throw n.code = "MODULE_NOT_FOUND", n;
        }

        var i = u[t] = {
          exports: {}
        };
        o[t][0].call(i.exports, function (e) {
          return s(o[t][1][e] || e);
        }, i, i.exports, a, o, u, c);
      }

      return u[t].exports;
    }

    for (var l = "function" == typeof require && require, e = 0; e < c.length; e++) {
      s(c[e]);
    }

    return s;
  }({
    1: [function (e, r, t) {
      !function (e) {
        "use strict";

        var t,
            C = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
            U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator,
            P = Math.ceil,
            R = Math.floor,
            I = "[BigNumber Error] ",
            $ = I + "Number primitive has more than 15 significant digits: ",
            G = 1e14,
            V = 14,
            q = 9007199254740991,
            Z = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
            z = 1e7,
            W = 1e9;

        function H(e) {
          var t = 0 | e;
          return 0 < e || e === t ? t : t - 1;
        }

        function Y(e) {
          for (var t, r, n = 1, i = e.length, a = e[0] + ""; n < i;) {
            for (t = e[n++] + "", r = V - t.length; r--; t = "0" + t) {
              ;
            }

            a += t;
          }

          for (i = a.length; 48 === a.charCodeAt(--i);) {
            ;
          }

          return a.slice(0, i + 1 || 1);
        }

        function K(e, t) {
          var r,
              n,
              i = e.c,
              a = t.c,
              o = e.s,
              u = t.s,
              c = e.e,
              s = t.e;
          if (!o || !u) return null;
          if (r = i && !i[0], n = a && !a[0], r || n) return r ? n ? 0 : -u : o;
          if (o != u) return o;
          if (r = o < 0, n = c == s, !i || !a) return n ? 0 : !i ^ r ? 1 : -1;
          if (!n) return s < c ^ r ? 1 : -1;

          for (u = (c = i.length) < (s = a.length) ? c : s, o = 0; o < u; o++) {
            if (i[o] != a[o]) return i[o] > a[o] ^ r ? 1 : -1;
          }

          return c == s ? 0 : s < c ^ r ? 1 : -1;
        }

        function J(e, t, r, n) {
          if (e < t || r < e || e !== R(e)) throw Error(I + (n || "Argument") + ("number" == typeof e ? e < t || r < e ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
        }

        function X(e) {
          var t = e.c.length - 1;
          return H(e.e / V) == t && e.c[t] % 2 != 0;
        }

        function Q(e, t) {
          return (1 < e.length ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
        }

        function ee(e, t, r) {
          var n, i;

          if (t < 0) {
            for (i = r + "."; ++t; i += r) {
              ;
            }

            e = i + e;
          } else if (++t > (n = e.length)) {
            for (i = r, t -= n; --t; i += r) {
              ;
            }

            e += i;
          } else t < n && (e = e.slice(0, t) + "." + e.slice(t));

          return e;
        }

        (t = function e(t) {
          var v,
              f,
              g,
              r,
              s,
              m,
              o,
              u,
              c,
              l,
              p,
              n = D.prototype = {
            constructor: D,
            toString: null,
            valueOf: null
          },
              d = new D(1),
              y = 20,
              b = 4,
              h = -7,
              w = 21,
              S = -1e7,
              O = 1e7,
              x = !1,
              a = 1,
              N = 0,
              B = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: " ",
            suffix: ""
          },
              M = "0123456789abcdefghijklmnopqrstuvwxyz";

          function D(e, t) {
            var r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l = this;
            if (!(l instanceof D)) return new D(e, t);

            if (null == t) {
              if (e && !0 === e._isBigNumber) return l.s = e.s, void (!e.c || e.e > O ? l.c = l.e = null : e.e < S ? l.c = [l.e = 0] : (l.e = e.e, l.c = e.c.slice()));

              if ((u = "number" == typeof e) && 0 * e == 0) {
                if (l.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                  for (a = 0, o = e; 10 <= o; o /= 10, a++) {
                    ;
                  }

                  return void (O < a ? l.c = l.e = null : (l.e = a, l.c = [e]));
                }

                s = String(e);
              } else {
                if (!C.test(s = String(e))) return g(l, s, u);
                l.s = 45 == s.charCodeAt(0) ? (s = s.slice(1), -1) : 1;
              }

              -1 < (a = s.indexOf(".")) && (s = s.replace(".", "")), 0 < (o = s.search(/e/i)) ? (a < 0 && (a = o), a += +s.slice(o + 1), s = s.substring(0, o)) : a < 0 && (a = s.length);
            } else {
              if (J(t, 2, M.length, "Base"), 10 == t) return j(l = new D(e), y + l.e + 1, b);

              if (s = String(e), u = "number" == typeof e) {
                if (0 * e != 0) return g(l, s, u, t);
                if (l.s = 1 / e < 0 ? (s = s.slice(1), -1) : 1, D.DEBUG && 15 < s.replace(/^0\.0*|\./, "").length) throw Error($ + e);
              } else l.s = 45 === s.charCodeAt(0) ? (s = s.slice(1), -1) : 1;

              for (r = M.slice(0, t), a = o = 0, c = s.length; o < c; o++) {
                if (r.indexOf(n = s.charAt(o)) < 0) {
                  if ("." == n) {
                    if (a < o) {
                      a = c;
                      continue;
                    }
                  } else if (!i && (s == s.toUpperCase() && (s = s.toLowerCase()) || s == s.toLowerCase() && (s = s.toUpperCase()))) {
                    i = !0, o = -1, a = 0;
                    continue;
                  }

                  return g(l, String(e), u, t);
                }
              }

              u = !1, -1 < (a = (s = f(s, t, 10, l.s)).indexOf(".")) ? s = s.replace(".", "") : a = s.length;
            }

            for (o = 0; 48 === s.charCodeAt(o); o++) {
              ;
            }

            for (c = s.length; 48 === s.charCodeAt(--c);) {
              ;
            }

            if (s = s.slice(o, ++c)) {
              if (c -= o, u && D.DEBUG && 15 < c && (q < e || e !== R(e))) throw Error($ + l.s * e);
              if ((a = a - o - 1) > O) l.c = l.e = null;else if (a < S) l.c = [l.e = 0];else {
                if (l.e = a, l.c = [], o = (a + 1) % V, a < 0 && (o += V), o < c) {
                  for (o && l.c.push(+s.slice(0, o)), c -= V; o < c;) {
                    l.c.push(+s.slice(o, o += V));
                  }

                  o = V - (s = s.slice(o)).length;
                } else o -= c;

                for (; o--; s += "0") {
                  ;
                }

                l.c.push(+s);
              }
            } else l.c = [l.e = 0];
          }

          function A(e, t, r, n) {
            for (var i, a, o = [0], u = 0, c = e.length; u < c;) {
              for (a = o.length; a--; o[a] *= t) {
                ;
              }

              for (o[0] += n.indexOf(e.charAt(u++)), i = 0; i < o.length; i++) {
                o[i] > r - 1 && (null == o[i + 1] && (o[i + 1] = 0), o[i + 1] += o[i] / r | 0, o[i] %= r);
              }
            }

            return o.reverse();
          }

          function F(e, t, r) {
            var n,
                i,
                a,
                o,
                u = 0,
                c = e.length,
                s = t % z,
                l = t / z | 0;

            for (e = e.slice(); c--;) {
              u = ((i = s * (a = e[c] % z) + (n = l * a + (o = e[c] / z | 0) * s) % z * z + u) / r | 0) + (n / z | 0) + l * o, e[c] = i % r;
            }

            return u && (e = [u].concat(e)), e;
          }

          function k(e, t, r, n) {
            var i, a;
            if (r != n) a = n < r ? 1 : -1;else for (i = a = 0; i < r; i++) {
              if (e[i] != t[i]) {
                a = e[i] > t[i] ? 1 : -1;
                break;
              }
            }
            return a;
          }

          function E(e, t, r, n) {
            for (var i = 0; r--;) {
              e[r] -= i, i = e[r] < t[r] ? 1 : 0, e[r] = i * n + e[r] - t[r];
            }

            for (; !e[0] && 1 < e.length; e.splice(0, 1)) {
              ;
            }
          }

          function i(e, t, r, n) {
            var i, a, o, u, c;
            if (null == r ? r = b : J(r, 0, 8), !e.c) return e.toString();
            if (i = e.c[0], o = e.e, null == t) c = Y(e.c), c = 1 == n || 2 == n && (o <= h || w <= o) ? Q(c, o) : ee(c, o, "0");else if (a = (e = j(new D(e), t, r)).e, u = (c = Y(e.c)).length, 1 == n || 2 == n && (t <= a || a <= h)) {
              for (; u < t; c += "0", u++) {
                ;
              }

              c = Q(c, a);
            } else if (t -= o, c = ee(c, a, "0"), u < a + 1) {
              if (0 < --t) for (c += "."; t--; c += "0") {
                ;
              }
            } else if (0 < (t += a - u)) for (a + 1 == u && (c += "."); t--; c += "0") {
              ;
            }
            return e.s < 0 && i ? "-" + c : c;
          }

          function _(e, t) {
            for (var r, n = 1, i = new D(e[0]); n < e.length; n++) {
              if (!(r = new D(e[n])).s) {
                i = r;
                break;
              }

              t.call(i, r) && (i = r);
            }

            return i;
          }

          function L(e, t, r) {
            for (var n = 1, i = t.length; !t[--i]; t.pop()) {
              ;
            }

            for (i = t[0]; 10 <= i; i /= 10, n++) {
              ;
            }

            return (r = n + r * V - 1) > O ? e.c = e.e = null : r < S ? e.c = [e.e = 0] : (e.e = r, e.c = t), e;
          }

          function j(e, t, r, n) {
            var i,
                a,
                o,
                u,
                c,
                s,
                l,
                f = e.c,
                g = Z;

            if (f) {
              e: {
                for (i = 1, u = f[0]; 10 <= u; u /= 10, i++) {
                  ;
                }

                if ((a = t - i) < 0) a += V, o = t, l = (c = f[s = 0]) / g[i - o - 1] % 10 | 0;else if ((s = P((a + 1) / V)) >= f.length) {
                  if (!n) break e;

                  for (; f.length <= s; f.push(0)) {
                    ;
                  }

                  c = l = 0, o = (a %= V) - V + (i = 1);
                } else {
                  for (c = u = f[s], i = 1; 10 <= u; u /= 10, i++) {
                    ;
                  }

                  l = (o = (a %= V) - V + i) < 0 ? 0 : c / g[i - o - 1] % 10 | 0;
                }
                if (n = n || t < 0 || null != f[s + 1] || (o < 0 ? c : c % g[i - o - 1]), n = r < 4 ? (l || n) && (0 == r || r == (e.s < 0 ? 3 : 2)) : 5 < l || 5 == l && (4 == r || n || 6 == r && (0 < a ? 0 < o ? c / g[i - o] : 0 : f[s - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !f[0]) return f.length = 0, n ? (t -= e.e + 1, f[0] = g[(V - t % V) % V], e.e = -t || 0) : f[0] = e.e = 0, e;
                if (0 == a ? (f.length = s, u = 1, s--) : (f.length = s + 1, u = g[V - a], f[s] = 0 < o ? R(c / g[i - o] % g[o]) * u : 0), n) for (;;) {
                  if (0 == s) {
                    for (a = 1, o = f[0]; 10 <= o; o /= 10, a++) {
                      ;
                    }

                    for (o = f[0] += u, u = 1; 10 <= o; o /= 10, u++) {
                      ;
                    }

                    a != u && (e.e++, f[0] == G && (f[0] = 1));
                    break;
                  }

                  if (f[s] += u, f[s] != G) break;
                  f[s--] = 0, u = 1;
                }

                for (a = f.length; 0 === f[--a]; f.pop()) {
                  ;
                }
              }

              e.e > O ? e.c = e.e = null : e.e < S && (e.c = [e.e = 0]);
            }

            return e;
          }

          function T(e) {
            var t,
                r = e.e;
            return null === r ? e.toString() : (t = Y(e.c), t = r <= h || w <= r ? Q(t, r) : ee(t, r, "0"), e.s < 0 ? "-" + t : t);
          }

          return D.clone = e, D.ROUND_UP = 0, D.ROUND_DOWN = 1, D.ROUND_CEIL = 2, D.ROUND_FLOOR = 3, D.ROUND_HALF_UP = 4, D.ROUND_HALF_DOWN = 5, D.ROUND_HALF_EVEN = 6, D.ROUND_HALF_CEIL = 7, D.ROUND_HALF_FLOOR = 8, D.EUCLID = 9, D.config = D.set = function (e) {
            var t, r;

            if (null != e) {
              if ("object" != typeof e) throw Error(I + "Object expected: " + e);
              if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (J(r = e[t], 0, W, t), y = r), e.hasOwnProperty(t = "ROUNDING_MODE") && (J(r = e[t], 0, 8, t), b = r), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((r = e[t]) && r.pop ? (J(r[0], -W, 0, t), J(r[1], 0, W, t), h = r[0], w = r[1]) : (J(r, -W, W, t), h = -(w = r < 0 ? -r : r))), e.hasOwnProperty(t = "RANGE")) if ((r = e[t]) && r.pop) J(r[0], -W, -1, t), J(r[1], 1, W, t), S = r[0], O = r[1];else {
                if (J(r, -W, W, t), !r) throw Error(I + t + " cannot be zero: " + r);
                S = -(O = r < 0 ? -r : r);
              }

              if (e.hasOwnProperty(t = "CRYPTO")) {
                if ((r = e[t]) !== !!r) throw Error(I + t + " not true or false: " + r);

                if (r) {
                  if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw x = !r, Error(I + "crypto unavailable");
                  x = r;
                } else x = r;
              }

              if (e.hasOwnProperty(t = "MODULO_MODE") && (J(r = e[t], 0, 9, t), a = r), e.hasOwnProperty(t = "POW_PRECISION") && (J(r = e[t], 0, W, t), N = r), e.hasOwnProperty(t = "FORMAT")) {
                if ("object" != typeof (r = e[t])) throw Error(I + t + " not an object: " + r);
                B = r;
              }

              if (e.hasOwnProperty(t = "ALPHABET")) {
                if ("string" != typeof (r = e[t]) || /^.$|[+-.\s]|(.).*\1/.test(r)) throw Error(I + t + " invalid: " + r);
                M = r;
              }
            }

            return {
              DECIMAL_PLACES: y,
              ROUNDING_MODE: b,
              EXPONENTIAL_AT: [h, w],
              RANGE: [S, O],
              CRYPTO: x,
              MODULO_MODE: a,
              POW_PRECISION: N,
              FORMAT: B,
              ALPHABET: M
            };
          }, D.isBigNumber = function (e) {
            if (!e || !0 !== e._isBigNumber) return !1;
            if (!D.DEBUG) return !0;
            var t,
                r,
                n = e.c,
                i = e.e,
                a = e.s;

            e: if ("[object Array]" == {}.toString.call(n)) {
              if ((1 === a || -1 === a) && -W <= i && i <= W && i === R(i)) {
                if (0 === n[0]) {
                  if (0 === i && 1 === n.length) return !0;
                  break e;
                }

                if ((t = (i + 1) % V) < 1 && (t += V), String(n[0]).length == t) {
                  for (t = 0; t < n.length; t++) {
                    if ((r = n[t]) < 0 || G <= r || r !== R(r)) break e;
                  }

                  if (0 !== r) return !0;
                }
              }
            } else if (null === n && null === i && (null === a || 1 === a || -1 === a)) return !0;

            throw Error(I + "Invalid BigNumber: " + e);
          }, D.maximum = D.max = function () {
            return _(arguments, n.lt);
          }, D.minimum = D.min = function () {
            return _(arguments, n.gt);
          }, D.random = (r = 9007199254740992, s = Math.random() * r & 2097151 ? function () {
            return R(Math.random() * r);
          } : function () {
            return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
          }, function (e) {
            var t,
                r,
                n,
                i,
                a,
                o = 0,
                u = [],
                c = new D(d);
            if (null == e ? e = y : J(e, 0, W), i = P(e / V), x) if (crypto.getRandomValues) {
              for (t = crypto.getRandomValues(new Uint32Array(i *= 2)); o < i;) {
                9e15 <= (a = 131072 * t[o] + (t[o + 1] >>> 11)) ? (r = crypto.getRandomValues(new Uint32Array(2)), t[o] = r[0], t[o + 1] = r[1]) : (u.push(a % 1e14), o += 2);
              }

              o = i / 2;
            } else {
              if (!crypto.randomBytes) throw x = !1, Error(I + "crypto unavailable");

              for (t = crypto.randomBytes(i *= 7); o < i;) {
                9e15 <= (a = 281474976710656 * (31 & t[o]) + 1099511627776 * t[o + 1] + 4294967296 * t[o + 2] + 16777216 * t[o + 3] + (t[o + 4] << 16) + (t[o + 5] << 8) + t[o + 6]) ? crypto.randomBytes(7).copy(t, o) : (u.push(a % 1e14), o += 7);
              }

              o = i / 7;
            }
            if (!x) for (; o < i;) {
              (a = s()) < 9e15 && (u[o++] = a % 1e14);
            }

            for (i = u[--o], e %= V, i && e && (a = Z[V - e], u[o] = R(i / a) * a); 0 === u[o]; u.pop(), o--) {
              ;
            }

            if (o < 0) u = [n = 0];else {
              for (n = -1; 0 === u[0]; u.splice(0, 1), n -= V) {
                ;
              }

              for (o = 1, a = u[0]; 10 <= a; a /= 10, o++) {
                ;
              }

              o < V && (n -= V - o);
            }
            return c.e = n, c.c = u, c;
          }), D.sum = function () {
            for (var e = 1, t = arguments, r = new D(t[0]); e < t.length;) {
              r = r.plus(t[e++]);
            }

            return r;
          }, m = "0123456789", f = function f(e, t, r, n, i) {
            var a,
                o,
                u,
                c,
                s,
                l,
                f,
                g,
                p = e.indexOf("."),
                h = y,
                d = b;

            for (0 <= p && (c = N, N = 0, e = e.replace(".", ""), l = (g = new D(t)).pow(e.length - p), N = c, g.c = A(ee(Y(l.c), l.e, "0"), 10, r, m), g.e = g.c.length), u = c = (f = A(e, t, r, i ? (a = M, m) : (a = m, M))).length; 0 == f[--c]; f.pop()) {
              ;
            }

            if (!f[0]) return a.charAt(0);
            if (p < 0 ? --u : (l.c = f, l.e = u, l.s = n, f = (l = v(l, g, h, d, r)).c, s = l.r, u = l.e), p = f[o = u + h + 1], c = r / 2, s = s || o < 0 || null != f[o + 1], s = d < 4 ? (null != p || s) && (0 == d || d == (l.s < 0 ? 3 : 2)) : c < p || p == c && (4 == d || s || 6 == d && 1 & f[o - 1] || d == (l.s < 0 ? 8 : 7)), o < 1 || !f[0]) e = s ? ee(a.charAt(1), -h, a.charAt(0)) : a.charAt(0);else {
              if (f.length = o, s) for (--r; ++f[--o] > r;) {
                f[o] = 0, o || (++u, f = [1].concat(f));
              }

              for (c = f.length; !f[--c];) {
                ;
              }

              for (p = 0, e = ""; p <= c; e += a.charAt(f[p++])) {
                ;
              }

              e = ee(e, u, a.charAt(0));
            }
            return e;
          }, v = function v(e, t, r, n, i) {
            var a,
                o,
                u,
                c,
                s,
                l,
                f,
                g,
                p,
                h,
                d,
                v,
                m,
                y,
                b,
                w,
                S,
                O = e.s == t.s ? 1 : -1,
                x = e.c,
                N = t.c;
            if (!(x && x[0] && N && N[0])) return new D(e.s && t.s && (x ? !N || x[0] != N[0] : N) ? x && 0 == x[0] || !N ? 0 * O : O / 0 : NaN);

            for (p = (g = new D(O)).c = [], O = r + (o = e.e - t.e) + 1, i || (i = G, o = H(e.e / V) - H(t.e / V), O = O / V | 0), u = 0; N[u] == (x[u] || 0); u++) {
              ;
            }

            if (N[u] > (x[u] || 0) && o--, O < 0) p.push(1), c = !0;else {
              for (y = x.length, w = N.length, O += 2, 1 < (s = R(i / (N[u = 0] + 1))) && (N = F(N, s, i), x = F(x, s, i), w = N.length, y = x.length), m = w, d = (h = x.slice(0, w)).length; d < w; h[d++] = 0) {
                ;
              }

              S = N.slice(), S = [0].concat(S), b = N[0], N[1] >= i / 2 && b++;

              do {
                if (s = 0, (a = k(N, h, w, d)) < 0) {
                  if (v = h[0], w != d && (v = v * i + (h[1] || 0)), 1 < (s = R(v / b))) for (i <= s && (s = i - 1), f = (l = F(N, s, i)).length, d = h.length; 1 == k(l, h, f, d);) {
                    s--, E(l, w < f ? S : N, f, i), f = l.length, a = 1;
                  } else 0 == s && (a = s = 1), f = (l = N.slice()).length;
                  if (f < d && (l = [0].concat(l)), E(h, l, d, i), d = h.length, -1 == a) for (; k(N, h, w, d) < 1;) {
                    s++, E(h, w < d ? S : N, d, i), d = h.length;
                  }
                } else 0 === a && (s++, h = [0]);

                p[u++] = s, h[0] ? h[d++] = x[m] || 0 : (h = [x[m]], d = 1);
              } while ((m++ < y || null != h[0]) && O--);

              c = null != h[0], p[0] || p.splice(0, 1);
            }

            if (i == G) {
              for (u = 1, O = p[0]; 10 <= O; O /= 10, u++) {
                ;
              }

              j(g, r + (g.e = u + o * V - 1) + 1, n, c);
            } else g.e = o, g.r = +c;

            return g;
          }, o = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, c = /^\.([^.]+)$/, l = /^-?(Infinity|NaN)$/, p = /^\s*\+(?=[\w.])|^\s+|\s+$/g, g = function g(e, t, r, n) {
            var i,
                a = r ? t : t.replace(p, "");
            if (l.test(a)) e.s = isNaN(a) ? null : a < 0 ? -1 : 1;else {
              if (!r && (a = a.replace(o, function (e, t, r) {
                return i = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != i ? e : t;
              }), n && (i = n, a = a.replace(u, "$1").replace(c, "0.$1")), t != a)) return new D(a, i);
              if (D.DEBUG) throw Error(I + "Not a" + (n ? " base " + n : "") + " number: " + t);
              e.s = null;
            }
            e.c = e.e = null;
          }, n.absoluteValue = n.abs = function () {
            var e = new D(this);
            return e.s < 0 && (e.s = 1), e;
          }, n.comparedTo = function (e, t) {
            return K(this, new D(e, t));
          }, n.decimalPlaces = n.dp = function (e, t) {
            var r, n, i;
            if (null != e) return J(e, 0, W), null == t ? t = b : J(t, 0, 8), j(new D(this), e + this.e + 1, t);
            if (!(r = this.c)) return null;
            if (n = ((i = r.length - 1) - H(this.e / V)) * V, i = r[i]) for (; i % 10 == 0; i /= 10, n--) {
              ;
            }
            return n < 0 && (n = 0), n;
          }, n.dividedBy = n.div = function (e, t) {
            return v(this, new D(e, t), y, b);
          }, n.dividedToIntegerBy = n.idiv = function (e, t) {
            return v(this, new D(e, t), 0, 1);
          }, n.exponentiatedBy = n.pow = function (e, t) {
            var r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l = this;
            if ((e = new D(e)).c && !e.isInteger()) throw Error(I + "Exponent not an integer: " + T(e));
            if (null != t && (t = new D(t)), o = 14 < e.e, !l.c || !l.c[0] || 1 == l.c[0] && !l.e && 1 == l.c.length || !e.c || !e.c[0]) return s = new D(Math.pow(+T(l), o ? 2 - X(e) : +T(e))), t ? s.mod(t) : s;

            if (u = e.s < 0, t) {
              if (t.c ? !t.c[0] : !t.s) return new D(NaN);
              (n = !u && l.isInteger() && t.isInteger()) && (l = l.mod(t));
            } else {
              if (9 < e.e && (0 < l.e || l.e < -1 || (0 == l.e ? 1 < l.c[0] || o && 24e7 <= l.c[1] : l.c[0] < 8e13 || o && l.c[0] <= 9999975e7))) return a = l.s < 0 && X(e) ? -0 : 0, -1 < l.e && (a = 1 / a), new D(u ? 1 / a : a);
              N && (a = P(N / V + 2));
            }

            for (c = o ? (r = new D(.5), u && (e.s = 1), X(e)) : (i = Math.abs(+T(e))) % 2, s = new D(d);;) {
              if (c) {
                if (!(s = s.times(l)).c) break;
                a ? s.c.length > a && (s.c.length = a) : n && (s = s.mod(t));
              }

              if (i) {
                if (0 === (i = R(i / 2))) break;
                c = i % 2;
              } else if (j(e = e.times(r), e.e + 1, 1), 14 < e.e) c = X(e);else {
                if (0 == (i = +T(e))) break;
                c = i % 2;
              }

              l = l.times(l), a ? l.c && l.c.length > a && (l.c.length = a) : n && (l = l.mod(t));
            }

            return n ? s : (u && (s = d.div(s)), t ? s.mod(t) : a ? j(s, N, b, void 0) : s);
          }, n.integerValue = function (e) {
            var t = new D(this);
            return null == e ? e = b : J(e, 0, 8), j(t, t.e + 1, e);
          }, n.isEqualTo = n.eq = function (e, t) {
            return 0 === K(this, new D(e, t));
          }, n.isFinite = function () {
            return !!this.c;
          }, n.isGreaterThan = n.gt = function (e, t) {
            return 0 < K(this, new D(e, t));
          }, n.isGreaterThanOrEqualTo = n.gte = function (e, t) {
            return 1 === (t = K(this, new D(e, t))) || 0 === t;
          }, n.isInteger = function () {
            return !!this.c && H(this.e / V) > this.c.length - 2;
          }, n.isLessThan = n.lt = function (e, t) {
            return K(this, new D(e, t)) < 0;
          }, n.isLessThanOrEqualTo = n.lte = function (e, t) {
            return -1 === (t = K(this, new D(e, t))) || 0 === t;
          }, n.isNaN = function () {
            return !this.s;
          }, n.isNegative = function () {
            return this.s < 0;
          }, n.isPositive = function () {
            return 0 < this.s;
          }, n.isZero = function () {
            return !!this.c && 0 == this.c[0];
          }, n.minus = function (e, t) {
            var r,
                n,
                i,
                a,
                o = this,
                u = o.s;
            if (t = (e = new D(e, t)).s, !u || !t) return new D(NaN);
            if (u != t) return e.s = -t, o.plus(e);
            var c = o.e / V,
                s = e.e / V,
                l = o.c,
                f = e.c;

            if (!c || !s) {
              if (!l || !f) return l ? (e.s = -t, e) : new D(f ? o : NaN);
              if (!l[0] || !f[0]) return f[0] ? (e.s = -t, e) : new D(l[0] ? o : 3 == b ? -0 : 0);
            }

            if (c = H(c), s = H(s), l = l.slice(), u = c - s) {
              for ((i = (a = u < 0) ? (u = -u, l) : (s = c, f)).reverse(), t = u; t--; i.push(0)) {
                ;
              }

              i.reverse();
            } else for (n = (a = (u = l.length) < (t = f.length)) ? u : t, u = t = 0; t < n; t++) {
              if (l[t] != f[t]) {
                a = l[t] < f[t];
                break;
              }
            }

            if (a && (i = l, l = f, f = i, e.s = -e.s), 0 < (t = (n = f.length) - (r = l.length))) for (; t--; l[r++] = 0) {
              ;
            }

            for (t = G - 1; u < n;) {
              if (l[--n] < f[n]) {
                for (r = n; r && !l[--r]; l[r] = t) {
                  ;
                }

                --l[r], l[n] += G;
              }

              l[n] -= f[n];
            }

            for (; 0 == l[0]; l.splice(0, 1), --s) {
              ;
            }

            return l[0] ? L(e, l, s) : (e.s = 3 == b ? -1 : 1, e.c = [e.e = 0], e);
          }, n.modulo = n.mod = function (e, t) {
            var r,
                n,
                i = this;
            return e = new D(e, t), !i.c || !e.s || e.c && !e.c[0] ? new D(NaN) : !e.c || i.c && !i.c[0] ? new D(i) : (9 == a ? (n = e.s, e.s = 1, r = v(i, e, 0, 3), e.s = n, r.s *= n) : r = v(i, e, 0, a), (e = i.minus(r.times(e))).c[0] || 1 != a || (e.s = i.s), e);
          }, n.multipliedBy = n.times = function (e, t) {
            var r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l,
                f,
                g,
                p,
                h,
                d,
                v,
                m = this,
                y = m.c,
                b = (e = new D(e, t)).c;
            if (!(y && b && y[0] && b[0])) return !m.s || !e.s || y && !y[0] && !b || b && !b[0] && !y ? e.c = e.e = e.s = null : (e.s *= m.s, y && b ? (e.c = [0], e.e = 0) : e.c = e.e = null), e;

            for (n = H(m.e / V) + H(e.e / V), e.s *= m.s, (c = y.length) < (f = b.length) && (h = y, y = b, b = h, i = c, c = f, f = i), i = c + f, h = []; i--; h.push(0)) {
              ;
            }

            for (d = G, v = z, i = f; 0 <= --i;) {
              for (r = 0, g = b[i] % v, p = b[i] / v | 0, a = i + (o = c); i < a;) {
                r = ((s = g * (s = y[--o] % v) + (u = p * s + (l = y[o] / v | 0) * g) % v * v + h[a] + r) / d | 0) + (u / v | 0) + p * l, h[a--] = s % d;
              }

              h[a] = r;
            }

            return r ? ++n : h.splice(0, 1), L(e, h, n);
          }, n.negated = function () {
            var e = new D(this);
            return e.s = -e.s || null, e;
          }, n.plus = function (e, t) {
            var r,
                n = this,
                i = n.s;
            if (t = (e = new D(e, t)).s, !i || !t) return new D(NaN);
            if (i != t) return e.s = -t, n.minus(e);
            var a = n.e / V,
                o = e.e / V,
                u = n.c,
                c = e.c;

            if (!a || !o) {
              if (!u || !c) return new D(i / 0);
              if (!u[0] || !c[0]) return c[0] ? e : new D(u[0] ? n : 0 * i);
            }

            if (a = H(a), o = H(o), u = u.slice(), i = a - o) {
              for ((r = 0 < i ? (o = a, c) : (i = -i, u)).reverse(); i--; r.push(0)) {
                ;
              }

              r.reverse();
            }

            for ((i = u.length) - (t = c.length) < 0 && (r = c, c = u, u = r, t = i), i = 0; t;) {
              i = (u[--t] = u[t] + c[t] + i) / G | 0, u[t] = G === u[t] ? 0 : u[t] % G;
            }

            return i && (u = [i].concat(u), ++o), L(e, u, o);
          }, n.precision = n.sd = function (e, t) {
            var r, n, i;
            if (null != e && e !== !!e) return J(e, 1, W), null == t ? t = b : J(t, 0, 8), j(new D(this), e, t);
            if (!(r = this.c)) return null;

            if (n = (i = r.length - 1) * V + 1, i = r[i]) {
              for (; i % 10 == 0; i /= 10, n--) {
                ;
              }

              for (i = r[0]; 10 <= i; i /= 10, n++) {
                ;
              }
            }

            return e && this.e + 1 > n && (n = this.e + 1), n;
          }, n.shiftedBy = function (e) {
            return J(e, -q, q), this.times("1e" + e);
          }, n.squareRoot = n.sqrt = function () {
            var e,
                t,
                r,
                n,
                i,
                a = this,
                o = a.c,
                u = a.s,
                c = a.e,
                s = y + 4,
                l = new D("0.5");
            if (1 !== u || !o || !o[0]) return new D(!u || u < 0 && (!o || o[0]) ? NaN : o ? a : 1 / 0);
            if ((r = 0 == (u = Math.sqrt(+T(a))) || u == 1 / 0 ? (((t = Y(o)).length + c) % 2 == 0 && (t += "0"), u = Math.sqrt(+t), c = H((c + 1) / 2) - (c < 0 || c % 2), new D(t = u == 1 / 0 ? "1e" + c : (t = u.toExponential()).slice(0, t.indexOf("e") + 1) + c)) : new D(u + "")).c[0]) for ((u = (c = r.e) + s) < 3 && (u = 0);;) {
              if (i = r, r = l.times(i.plus(v(a, i, s, 1))), Y(i.c).slice(0, u) === (t = Y(r.c)).slice(0, u)) {
                if (r.e < c && --u, "9999" != (t = t.slice(u - 3, u + 1)) && (n || "4999" != t)) {
                  +t && (+t.slice(1) || "5" != t.charAt(0)) || (j(r, r.e + y + 2, 1), e = !r.times(r).eq(a));
                  break;
                }

                if (!n && (j(i, i.e + y + 2, 0), i.times(i).eq(a))) {
                  r = i;
                  break;
                }

                s += 4, u += 4, n = 1;
              }
            }
            return j(r, r.e + y + 1, b, e);
          }, n.toExponential = function (e, t) {
            return null != e && (J(e, 0, W), e++), i(this, e, t, 1);
          }, n.toFixed = function (e, t) {
            return null != e && (J(e, 0, W), e = e + this.e + 1), i(this, e, t);
          }, n.toFormat = function (e, t, r) {
            var n;
            if (null == r) null != e && t && "object" == typeof t ? (r = t, t = null) : e && "object" == typeof e ? (r = e, e = t = null) : r = B;else if ("object" != typeof r) throw Error(I + "Argument not an object: " + r);

            if (n = this.toFixed(e, t), this.c) {
              var i,
                  a = n.split("."),
                  o = +r.groupSize,
                  u = +r.secondaryGroupSize,
                  c = r.groupSeparator || "",
                  s = a[0],
                  l = a[1],
                  f = this.s < 0,
                  g = f ? s.slice(1) : s,
                  p = g.length;

              if (u && (i = o, o = u, p -= u = i), 0 < o && 0 < p) {
                for (i = p % o || o, s = g.substr(0, i); i < p; i += o) {
                  s += c + g.substr(i, o);
                }

                0 < u && (s += c + g.slice(i)), f && (s = "-" + s);
              }

              n = l ? s + (r.decimalSeparator || "") + ((u = +r.fractionGroupSize) ? l.replace(new RegExp("\\d{" + u + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : l) : s;
            }

            return (r.prefix || "") + n + (r.suffix || "");
          }, n.toFraction = function (e) {
            var t,
                r,
                n,
                i,
                a,
                o,
                u,
                c,
                s,
                l,
                f,
                g,
                p = this,
                h = p.c;
            if (null != e && (!(u = new D(e)).isInteger() && (u.c || 1 !== u.s) || u.lt(d))) throw Error(I + "Argument " + (u.isInteger() ? "out of range: " : "not an integer: ") + T(u));
            if (!h) return new D(p);

            for (t = new D(d), s = r = new D(d), n = c = new D(d), g = Y(h), a = t.e = g.length - p.e - 1, t.c[0] = Z[(o = a % V) < 0 ? V + o : o], e = !e || 0 < u.comparedTo(t) ? 0 < a ? t : s : u, o = O, O = 1 / 0, u = new D(g), c.c[0] = 0; l = v(u, t, 0, 1), 1 != (i = r.plus(l.times(n))).comparedTo(e);) {
              r = n, n = i, s = c.plus(l.times(i = s)), c = i, t = u.minus(l.times(i = t)), u = i;
            }

            return i = v(e.minus(r), n, 0, 1), c = c.plus(i.times(s)), r = r.plus(i.times(n)), c.s = s.s = p.s, f = v(s, n, a *= 2, b).minus(p).abs().comparedTo(v(c, r, a, b).minus(p).abs()) < 1 ? [s, n] : [c, r], O = o, f;
          }, n.toNumber = function () {
            return +T(this);
          }, n.toPrecision = function (e, t) {
            return null != e && J(e, 1, W), i(this, e, t, 2);
          }, n.toString = function (e) {
            var t,
                r = this,
                n = r.s,
                i = r.e;
            return null === i ? n ? (t = "Infinity", n < 0 && (t = "-" + t)) : t = "NaN" : (t = null == e ? i <= h || w <= i ? Q(Y(r.c), i) : ee(Y(r.c), i, "0") : 10 === e ? ee(Y((r = j(new D(r), y + i + 1, b)).c), r.e, "0") : (J(e, 2, M.length, "Base"), f(ee(Y(r.c), i, "0"), 10, e, n, !0)), n < 0 && r.c[0] && (t = "-" + t)), t;
          }, n.valueOf = n.toJSON = function () {
            return T(this);
          }, n._isBigNumber = !0, U && (n[Symbol.toStringTag] = "BigNumber", n[Symbol["for"]("nodejs.util.inspect.custom")] = n.valueOf), null != t && D.set(t), D;
        }())["default"] = t.BigNumber = t, void 0 !== r && r.exports ? r.exports = t : (e = e || ("undefined" != typeof self && self ? self : window)).BigNumber = t;
      }(this);
    }, {}],
    2: [function (e, t, r) {
      "use strict";

      t.exports = {
        languageTag: "en-US",
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        spaceSeparated: !1,
        ordinal: function ordinal(e) {
          var t = e % 10;
          return 1 == ~~(e % 100 / 10) ? "th" : 1 == t ? "st" : 2 == t ? "nd" : 3 == t ? "rd" : "th";
        },
        bytes: {
          binarySuffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
          decimalSuffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        },
        currency: {
          symbol: "$",
          position: "prefix",
          code: "USD"
        },
        currencyFormat: {
          thousandSeparated: !0,
          totalLength: 4,
          spaceSeparated: !0,
          spaceSeparatedCurrency: !0
        },
        formats: {
          fourDigits: {
            totalLength: 4,
            spaceSeparated: !0
          },
          fullWithTwoDecimals: {
            output: "currency",
            thousandSeparated: !0,
            mantissa: 2
          },
          fullWithTwoDecimalsNoCurrency: {
            thousandSeparated: !0,
            mantissa: 2
          },
          fullWithNoDecimals: {
            output: "currency",
            thousandSeparated: !0,
            mantissa: 0
          }
        }
      };
    }, {}],
    3: [function (e, t, r) {
      "use strict";

      function R(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
          var r = [],
              n = !0,
              i = !1,
              a = void 0;

          try {
            for (var o, u = e[Symbol.iterator](); !(n = (o = u.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (e) {
            i = !0, a = e;
          } finally {
            try {
              n || null == u["return"] || u["return"]();
            } finally {
              if (i) throw a;
            }
          }

          return r;
        }(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }

      var I = e("./globalState"),
          o = e("./validating"),
          u = e("./parsing"),
          $ = {
        trillion: Math.pow(10, 12),
        billion: Math.pow(10, 9),
        million: Math.pow(10, 6),
        thousand: Math.pow(10, 3)
      },
          G = {
        totalLength: 0,
        characteristic: 0,
        forceAverage: !1,
        average: !1,
        mantissa: -1,
        optionalMantissa: !0,
        thousandSeparated: !1,
        spaceSeparated: !1,
        negative: "sign",
        forceSign: !1,
        roundingFunction: Math.round
      },
          n = I.currentBytes(),
          i = n.binarySuffixes,
          a = n.decimalSuffixes,
          c = {
        general: {
          scale: 1024,
          suffixes: a,
          marker: "bd"
        },
        binary: {
          scale: 1024,
          suffixes: i,
          marker: "b"
        },
        decimal: {
          scale: 1e3,
          suffixes: a,
          marker: "d"
        }
      };

      function s(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
            r = 2 < arguments.length ? arguments[2] : void 0;
        if ("string" == typeof t && (t = u.parseFormat(t)), !o.validateFormat(t)) return "ERROR: invalid format";

        var n = t.prefix || "",
            i = t.postfix || "",
            a = function (e, t, r) {
          switch (t.output) {
            case "currency":
              return t = l(t, I.currentCurrencyDefaultFormat()), function (e, t, r) {
                var n = r.currentCurrency(),
                    i = Object.assign({}, G, t),
                    a = void 0,
                    o = "",
                    u = !!i.totalLength || !!i.forceAverage || i.average,
                    c = t.currencyPosition || n.position,
                    s = t.currencySymbol || n.symbol;
                (void 0 !== i.spaceSeparatedCurrency ? i.spaceSeparatedCurrency : i.spaceSeparated) && (o = " ");
                "infix" === c && (a = o + s + o);
                var l = d({
                  instance: e,
                  providedFormat: t,
                  state: r,
                  decimalSeparator: a
                });
                "prefix" === c && (l = e._value < 0 && "sign" === i.negative ? "-".concat(o).concat(s).concat(l.slice(1)) : 0 < e._value && i.forceSign ? "+".concat(o).concat(s).concat(l.slice(1)) : s + o + l);
                c && "postfix" !== c || (l = l + (o = u ? "" : o) + s);
                return l;
              }(e, t, I);

            case "percent":
              return t = l(t, I.currentPercentageDefaultFormat()), function (e, t, r, n) {
                var i = t.prefixSymbol,
                    a = d({
                  instance: n(100 * e._value),
                  providedFormat: t,
                  state: r
                }),
                    o = Object.assign({}, G, t);
                if (i) return "%".concat(o.spaceSeparated ? " " : "").concat(a);
                return "".concat(a).concat(o.spaceSeparated ? " " : "", "%");
              }(e, t, I, r);

            case "byte":
              return t = l(t, I.currentByteDefaultFormat()), function (e, t, r, n) {
                var i = t.base || "binary",
                    a = r.currentBytes(),
                    o = a.binarySuffixes,
                    u = a.decimalSuffixes,
                    c = {
                  general: {
                    scale: 1024,
                    suffixes: u,
                    marker: "bd"
                  },
                  binary: {
                    scale: 1024,
                    suffixes: o,
                    marker: "b"
                  },
                  decimal: {
                    scale: 1e3,
                    suffixes: u,
                    marker: "d"
                  }
                }[i],
                    s = h(e._value, c.suffixes, c.scale),
                    l = s.value,
                    f = s.suffix,
                    g = d({
                  instance: n(l),
                  providedFormat: t,
                  state: r,
                  defaults: r.currentByteDefaultFormat()
                }),
                    p = r.currentAbbreviations();
                return "".concat(g).concat(p.spaced ? " " : "").concat(f);
              }(e, t, I, r);

            case "time":
              return t = l(t, I.currentTimeDefaultFormat()), function (e) {
                var t = Math.floor(e._value / 60 / 60),
                    r = Math.floor((e._value - 60 * t * 60) / 60),
                    n = Math.round(e._value - 60 * t * 60 - 60 * r);
                return "".concat(t, ":").concat(r < 10 ? "0" : "").concat(r, ":").concat(n < 10 ? "0" : "").concat(n);
              }(e);

            case "ordinal":
              return t = l(t, I.currentOrdinalDefaultFormat()), function (e, t, r) {
                var n = r.currentOrdinal(),
                    i = Object.assign({}, G, t),
                    a = d({
                  instance: e,
                  providedFormat: t,
                  state: r
                }),
                    o = n(e._value);
                return "".concat(a).concat(i.spaceSeparated ? " " : "").concat(o);
              }(e, t, I);

            case "number":
            default:
              return d({
                instance: e,
                providedFormat: t,
                numbro: r
              });
          }
        }(e, t, r);

        return a = (a = n + a) + i;
      }

      function h(e, t, r) {
        var n = t[0],
            i = Math.abs(e);

        if (r <= i) {
          for (var a = 1; a < t.length; ++a) {
            var o = Math.pow(r, a),
                u = Math.pow(r, a + 1);

            if (o <= i && i < u) {
              n = t[a], e /= o;
              break;
            }
          }

          n === t[0] && (e /= Math.pow(r, t.length - 1), n = t[t.length - 1]);
        }

        return {
          value: e,
          suffix: n
        };
      }

      function g(e) {
        for (var t = "", r = 0; r < e; r++) {
          t += "0";
        }

        return t;
      }

      function V(e, t, r) {
        var n = 2 < arguments.length && void 0 !== r ? r : Math.round;
        return -1 !== e.toString().indexOf("e") ? function (e, t) {
          var r = e.toString(),
              n = R(r.split("e"), 2),
              i = n[0],
              a = n[1],
              o = R(i.split("."), 2),
              u = o[0],
              c = o[1],
              s = void 0 === c ? "" : c;
          if (0 < +a) r = u + s + g(a - s.length);else {
            var l = ".";
            l = +u < 0 ? "-0".concat(l) : "0".concat(l);
            var f = (g(-a - 1) + Math.abs(u) + s).substr(0, t);
            f.length < t && (f += g(t - f.length)), r = l + f;
          }
          return 0 < +a && 0 < t && (r += ".".concat(g(t))), r;
        }(e, t) : (n(+"".concat(e, "e+").concat(t)) / Math.pow(10, t)).toFixed(t);
      }

      function q(e, t, r, n, i) {
        var a = n.currentDelimiters(),
            o = a.thousands;
        i = i || a.decimal;
        var u = a.thousandsSize || 3,
            c = e.toString(),
            s = c.split(".")[0],
            l = c.split(".")[1],
            f = t < 0 && 0 === s.indexOf("-");
        r && (f && (s = s.slice(1)), function (e, t) {
          for (var r = [], n = 0, i = e; 0 < i; i--) {
            n === t && (r.unshift(i), n = 0), n++;
          }

          return r;
        }(s.length, u).forEach(function (e, t) {
          s = s.slice(0, e + t) + o + s.slice(e + t);
        }), f && (s = "-".concat(s)));
        return c = l ? s + i + l : s;
      }

      function d(e) {
        var t = e.instance,
            r = e.providedFormat,
            n = e.state,
            i = void 0 === n ? I : n,
            a = e.decimalSeparator,
            o = e.defaults,
            u = void 0 === o ? i.currentDefaults() : o,
            c = t._value;
        if (0 === c && i.hasZeroFormat()) return i.getZeroFormat();
        if (!isFinite(c)) return c.toString();
        var s,
            l,
            f,
            g,
            p,
            h,
            d,
            v,
            m = Object.assign({}, G, u, r),
            y = m.totalLength,
            b = y ? 0 : m.characteristic,
            w = m.optionalCharacteristic,
            S = m.forceAverage,
            O = !!y || !!S || m.average,
            x = y ? -1 : O && void 0 === r.mantissa ? 0 : m.mantissa,
            N = !y && (void 0 === r.optionalMantissa ? -1 === x : m.optionalMantissa),
            B = m.trimMantissa,
            M = m.thousandSeparated,
            D = m.spaceSeparated,
            A = m.negative,
            F = m.forceSign,
            k = m.exponential,
            E = m.roundingFunction,
            _ = "";

        if (O) {
          var L = function (e) {
            var t = e.value,
                r = e.forceAverage,
                n = e.abbreviations,
                i = e.spaceSeparated,
                a = void 0 !== i && i,
                o = e.totalLength,
                u = void 0 === o ? 0 : o,
                c = e.roundingFunction,
                s = void 0 === c ? Math.round : c,
                l = "",
                f = Math.abs(t),
                g = -1;

            if (r && n[r] && $[r] ? (l = n[r], t /= $[r]) : f >= $.trillion || 1 === s(f / $.trillion) ? (l = n.trillion, t /= $.trillion) : f < $.trillion && f >= $.billion || 1 === s(f / $.billion) ? (l = n.billion, t /= $.billion) : f < $.billion && f >= $.million || 1 === s(f / $.million) ? (l = n.million, t /= $.million) : (f < $.million && f >= $.thousand || 1 === s(f / $.thousand)) && (l = n.thousand, t /= $.thousand), l = l && (a ? " " : "") + l, u) {
              var p = t < 0,
                  h = t.toString().split(".")[0],
                  d = p ? h.length - 1 : h.length;
              g = Math.max(u - d, 0);
            }

            return {
              value: t,
              abbreviation: l,
              mantissaPrecision: g
            };
          }({
            value: c,
            forceAverage: S,
            abbreviations: i.currentAbbreviations(),
            spaceSeparated: D,
            roundingFunction: E,
            totalLength: y
          });

          c = L.value, _ += L.abbreviation, y && (x = L.mantissaPrecision);
        }

        if (k) {
          var j = (l = (s = {
            value: c,
            characteristicPrecision: b
          }).value, f = s.characteristicPrecision, g = void 0 === f ? 0 : f, p = R(l.toExponential().split("e"), 2), h = p[0], d = p[1], v = +h, g && 1 < g && (v *= Math.pow(10, g - 1), d = 0 <= (d -= g - 1) ? "+".concat(d) : d), {
            value: v,
            abbreviation: "e".concat(d)
          });
          c = j.value, _ = j.abbreviation + _;
        }

        var T,
            C,
            U,
            P = function (e, t, r, n, i, a) {
          if (-1 === n) return e;
          var o = V(t, n, a),
              u = R(o.toString().split("."), 2),
              c = u[0],
              s = u[1],
              l = void 0 === s ? "" : s;
          if (l.match(/^0+$/) && (r || i)) return c;
          var f = l.match(/0+$/);
          return i && f ? "".concat(c, ".").concat(l.toString().slice(0, f.index)) : o.toString();
        }(c.toString(), c, N, x, B, E);

        return P = q(P = function (e, t, r, n) {
          var i = e,
              a = R(i.toString().split("."), 2),
              o = a[0],
              u = a[1];
          if (o.match(/^-?0$/) && r) return u ? "".concat(o.replace("0", ""), ".").concat(u) : o.replace("0", "");
          var c = t < 0 && 0 === o.indexOf("-");
          if (c && (o = o.slice(1), i = i.slice(1)), o.length < n) for (var s = n - o.length, l = 0; l < s; l++) {
            i = "0".concat(i);
          }
          return c && (i = "-".concat(i)), i.toString();
        }(P, c, w, b), c, M, i, a), (O || k) && (P = P + _), (F || c < 0) && (T = P, U = A, P = 0 === (C = c) ? T : 0 == +T ? T.replace("-", "") : 0 < C ? "+".concat(T) : "sign" === U ? T : "(".concat(T.replace("-", ""), ")")), P;
      }

      function l(e, t) {
        if (!e) return t;
        var r = Object.keys(e);
        return 1 === r.length && "output" === r[0] ? t : e;
      }

      t.exports = function (n) {
        return {
          format: function format() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return s.apply(void 0, t.concat([n]));
          },
          getByteUnit: function getByteUnit() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return function (e) {
              var t = c.general;
              return h(e._value, t.suffixes, t.scale).suffix;
            }.apply(void 0, t.concat([n]));
          },
          getBinaryByteUnit: function getBinaryByteUnit() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return function (e) {
              var t = c.binary;
              return h(e._value, t.suffixes, t.scale).suffix;
            }.apply(void 0, t.concat([n]));
          },
          getDecimalByteUnit: function getDecimalByteUnit() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
              t[r] = arguments[r];
            }

            return function (e) {
              var t = c.decimal;
              return h(e._value, t.suffixes, t.scale).suffix;
            }.apply(void 0, t.concat([n]));
          },
          formatOrDefault: l
        };
      };
    }, {
      "./globalState": 4,
      "./parsing": 8,
      "./validating": 10
    }],
    4: [function (e, t, r) {
      "use strict";

      var i = e("./en-US"),
          n = e("./validating"),
          a = e("./parsing"),
          o = {},
          u = void 0,
          c = {},
          s = null,
          l = {};

      function f(e) {
        u = e;
      }

      function g() {
        return c[u];
      }

      o.languages = function () {
        return Object.assign({}, c);
      }, o.currentLanguage = function () {
        return u;
      }, o.currentBytes = function () {
        return g().bytes;
      }, o.currentCurrency = function () {
        return g().currency;
      }, o.currentAbbreviations = function () {
        return g().abbreviations;
      }, o.currentDelimiters = function () {
        return g().delimiters;
      }, o.currentOrdinal = function () {
        return g().ordinal;
      }, o.currentDefaults = function () {
        return Object.assign({}, g().defaults, l);
      }, o.currentOrdinalDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), g().ordinalFormat);
      }, o.currentByteDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), g().byteFormat);
      }, o.currentPercentageDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), g().percentageFormat);
      }, o.currentCurrencyDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), g().currencyFormat);
      }, o.currentTimeDefaultFormat = function () {
        return Object.assign({}, o.currentDefaults(), g().timeFormat);
      }, o.setDefaults = function (e) {
        e = a.parseFormat(e), n.validateFormat(e) && (l = e);
      }, o.getZeroFormat = function () {
        return s;
      }, o.setZeroFormat = function (e) {
        return s = "string" == typeof e ? e : null;
      }, o.hasZeroFormat = function () {
        return null !== s;
      }, o.languageData = function (e) {
        if (e) {
          if (c[e]) return c[e];
          throw new Error('Unknown tag "'.concat(e, '"'));
        }

        return g();
      }, o.registerLanguage = function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
        if (!n.validateLanguage(e)) throw new Error("Invalid language data");
        c[e.languageTag] = e, t && f(e.languageTag);
      }, o.setLanguage = function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : i.languageTag;

        if (!c[e]) {
          var r = e.split("-")[0],
              n = Object.keys(c).find(function (e) {
            return e.split("-")[0] === r;
          });
          return c[n] ? void f(n) : void f(t);
        }

        f(e);
      }, o.registerLanguage(i), u = i.languageTag, t.exports = o;
    }, {
      "./en-US": 2,
      "./parsing": 8,
      "./validating": 10
    }],
    5: [function (n, e, t) {
      "use strict";

      e.exports = function (t) {
        return {
          loadLanguagesInNode: function loadLanguagesInNode(e) {
            return r = t, void e.forEach(function (t) {
              var e = void 0;

              try {
                e = n("../languages/".concat(t));
              } catch (e) {
                console.error('Unable to load "'.concat(t, '". No matching language file found.'));
              }

              e && r.registerLanguage(e);
            });
            var r;
          }
        };
      };
    }, {}],
    6: [function (e, t, r) {
      "use strict";

      var c = e("bignumber.js");

      function a(e, t, r) {
        var n = new c(e._value),
            i = t;
        return r.isNumbro(t) && (i = t._value), i = new c(i), e._value = n.minus(i).toNumber(), e;
      }

      t.exports = function (u) {
        return {
          add: function add(e, t) {
            return n = t, i = u, a = new c((r = e)._value), o = n, i.isNumbro(n) && (o = n._value), o = new c(o), r._value = a.plus(o).toNumber(), r;
            var r, n, i, a, o;
          },
          subtract: function subtract(e, t) {
            return a(e, t, u);
          },
          multiply: function multiply(e, t) {
            return n = t, i = u, a = new c((r = e)._value), o = n, i.isNumbro(n) && (o = n._value), o = new c(o), r._value = a.times(o).toNumber(), r;
            var r, n, i, a, o;
          },
          divide: function divide(e, t) {
            return n = t, i = u, a = new c((r = e)._value), o = n, i.isNumbro(n) && (o = n._value), o = new c(o), r._value = a.dividedBy(o).toNumber(), r;
            var r, n, i, a, o;
          },
          set: function set(e, t) {
            return r = e, i = n = t, u.isNumbro(n) && (i = n._value), r._value = i, r;
            var r, n, i;
          },
          difference: function difference(e, t) {
            return r = t, a(i = (n = u)(e._value), r, n), Math.abs(i._value);
            var r, n, i;
          },
          BigNumber: c
        };
      };
    }, {
      "bignumber.js": 1
    }],
    7: [function (e, t, r) {
      "use strict";

      function i(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var a = e("./globalState"),
          n = e("./validating"),
          o = e("./loading")(p),
          u = e("./unformatting"),
          c = e("./formatting")(p),
          s = e("./manipulating")(p),
          l = e("./parsing"),
          f = function () {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this._value = e;
        }

        var e, r, n;
        return e = t, (r = [{
          key: "clone",
          value: function value() {
            return p(this._value);
          }
        }, {
          key: "format",
          value: function value(e) {
            var t = 0 < arguments.length && void 0 !== e ? e : {};
            return c.format(this, t);
          }
        }, {
          key: "formatCurrency",
          value: function value(e) {
            return "string" == typeof e && (e = l.parseFormat(e)), (e = c.formatOrDefault(e, a.currentCurrencyDefaultFormat())).output = "currency", c.format(this, e);
          }
        }, {
          key: "formatTime",
          value: function value(e) {
            var t = 0 < arguments.length && void 0 !== e ? e : {};
            return t.output = "time", c.format(this, t);
          }
        }, {
          key: "binaryByteUnits",
          value: function value() {
            return c.getBinaryByteUnit(this);
          }
        }, {
          key: "decimalByteUnits",
          value: function value() {
            return c.getDecimalByteUnit(this);
          }
        }, {
          key: "byteUnits",
          value: function value() {
            return c.getByteUnit(this);
          }
        }, {
          key: "difference",
          value: function value(e) {
            return s.difference(this, e);
          }
        }, {
          key: "add",
          value: function value(e) {
            return s.add(this, e);
          }
        }, {
          key: "subtract",
          value: function value(e) {
            return s.subtract(this, e);
          }
        }, {
          key: "multiply",
          value: function value(e) {
            return s.multiply(this, e);
          }
        }, {
          key: "divide",
          value: function value(e) {
            return s.divide(this, e);
          }
        }, {
          key: "set",
          value: function value(e) {
            return s.set(this, g(e));
          }
        }, {
          key: "value",
          value: function value() {
            return this._value;
          }
        }, {
          key: "valueOf",
          value: function value() {
            return this._value;
          }
        }]) && i(e.prototype, r), n && i(e, n), t;
      }();

      function g(e) {
        var t = e;
        return p.isNumbro(e) ? t = e._value : "string" == typeof e ? t = p.unformat(e) : isNaN(e) && (t = NaN), t;
      }

      function p(e) {
        return new f(g(e));
      }

      p.version = "2.3.0", p.isNumbro = function (e) {
        return e instanceof f;
      }, p.language = a.currentLanguage, p.registerLanguage = a.registerLanguage, p.setLanguage = a.setLanguage, p.languages = a.languages, p.languageData = a.languageData, p.zeroFormat = a.setZeroFormat, p.defaultFormat = a.currentDefaults, p.setDefaults = a.setDefaults, p.defaultCurrencyFormat = a.currentCurrencyDefaultFormat, p.validate = n.validate, p.loadLanguagesInNode = o.loadLanguagesInNode, p.unformat = u.unformat, p.BigNumber = s.BigNumber, t.exports = p;
    }, {
      "./formatting": 3,
      "./globalState": 4,
      "./loading": 5,
      "./manipulating": 6,
      "./parsing": 8,
      "./unformatting": 9,
      "./validating": 10
    }],
    8: [function (e, t, r) {
      "use strict";

      t.exports = {
        parseFormat: function parseFormat(e) {
          var t,
              r,
              n,
              i,
              a,
              o,
              u,
              c,
              s,
              l,
              f,
              g,
              p,
              h,
              d,
              v,
              m,
              y,
              b,
              w,
              S = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" != typeof e ? e : (r = S, e = (n = (t = e).match(/^{([^}]*)}/)) ? (r.prefix = n[1], t.slice(n[0].length)) : t, a = S, function (e, t) {
            if (-1 === e.indexOf("$")) {
              if (-1 === e.indexOf("%")) return -1 !== e.indexOf("bd") ? (t.output = "byte", t.base = "general") : -1 !== e.indexOf("b") ? (t.output = "byte", t.base = "binary") : -1 !== e.indexOf("d") ? (t.output = "byte", t.base = "decimal") : -1 === e.indexOf(":") ? -1 !== e.indexOf("o") && (t.output = "ordinal") : t.output = "time";
              t.output = "percent";
            } else t.output = "currency";
          }(e = (o = (i = e).match(/{([^}]*)}$/)) ? (a.postfix = o[1], i.slice(0, -o[0].length)) : i, S), u = S, (c = e.match(/[1-9]+[0-9]*/)) && (u.totalLength = +c[0]), s = S, (l = e.split(".")[0].match(/0+/)) && (s.characteristic = l[0].length), function (e, t) {
            if (-1 !== e.indexOf(".")) {
              var r = e.split(".")[0];
              t.optionalCharacteristic = -1 === r.indexOf("0");
            }
          }(e, S), f = S, -1 !== e.indexOf("a") && (f.average = !0), p = S, -1 !== (g = e).indexOf("K") ? p.forceAverage = "thousand" : -1 !== g.indexOf("M") ? p.forceAverage = "million" : -1 !== g.indexOf("B") ? p.forceAverage = "billion" : -1 !== g.indexOf("T") && (p.forceAverage = "trillion"), function (e, t) {
            var r = e.split(".")[1];

            if (r) {
              var n = r.match(/0+/);
              n && (t.mantissa = n[0].length);
            }
          }(e, S), d = S, (h = e).match(/\[\.]/) ? d.optionalMantissa = !0 : h.match(/\./) && (d.optionalMantissa = !1), v = S, -1 !== e.indexOf(",") && (v.thousandSeparated = !0), m = S, -1 !== e.indexOf(" ") && (m.spaceSeparated = !0, m.spaceSeparatedCurrency = !0), b = S, (y = e).match(/^\+?\([^)]*\)$/) && (b.negative = "parenthesis"), y.match(/^\+?-/) && (b.negative = "sign"), w = S, e.match(/^\+/) && (w.forceSign = !0), S);
        }
      };
    }, {}],
    9: [function (g, e, t) {
      "use strict";

      var M = [{
        key: "ZiB",
        factor: Math.pow(1024, 7)
      }, {
        key: "ZB",
        factor: Math.pow(1e3, 7)
      }, {
        key: "YiB",
        factor: Math.pow(1024, 8)
      }, {
        key: "YB",
        factor: Math.pow(1e3, 8)
      }, {
        key: "TiB",
        factor: Math.pow(1024, 4)
      }, {
        key: "TB",
        factor: Math.pow(1e3, 4)
      }, {
        key: "PiB",
        factor: Math.pow(1024, 5)
      }, {
        key: "PB",
        factor: Math.pow(1e3, 5)
      }, {
        key: "MiB",
        factor: Math.pow(1024, 2)
      }, {
        key: "MB",
        factor: Math.pow(1e3, 2)
      }, {
        key: "KiB",
        factor: Math.pow(1024, 1)
      }, {
        key: "KB",
        factor: Math.pow(1e3, 1)
      }, {
        key: "GiB",
        factor: Math.pow(1024, 3)
      }, {
        key: "GB",
        factor: Math.pow(1e3, 3)
      }, {
        key: "EiB",
        factor: Math.pow(1024, 6)
      }, {
        key: "EB",
        factor: Math.pow(1e3, 6)
      }, {
        key: "B",
        factor: 1
      }];

      function D(e) {
        return e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      function p(e, t, r, n, i, a, o) {
        var u = 2 < arguments.length && void 0 !== r ? r : "",
            c = 3 < arguments.length ? n : void 0,
            s = 4 < arguments.length ? i : void 0,
            l = 5 < arguments.length ? a : void 0,
            f = 6 < arguments.length ? o : void 0;
        if ("" !== e) return e === s ? 0 : function e(t, r, n, i, a, o, u) {
          var c = 2 < arguments.length && void 0 !== n ? n : "",
              s = 3 < arguments.length ? i : void 0,
              l = 4 < arguments.length ? a : void 0,
              f = 5 < arguments.length ? o : void 0,
              g = 6 < arguments.length ? u : void 0;
          if (!isNaN(+t)) return +t;
          var p = "",
              h = t.replace(/(^[^(]*)\((.*)\)([^)]*$)/, "$1$2$3");
          if (h !== t) return -1 * e(h, r, c, s, l, f, g);

          for (var d = 0; d < M.length; d++) {
            var v = M[d];
            if ((p = t.replace(v.key, "")) !== t) return e(p, r, c, s, l, f, g) * v.factor;
          }

          if ((p = t.replace("%", "")) !== t) return e(p, r, c, s, l, f, g) / 100;
          var m = parseFloat(t);

          if (!isNaN(m)) {
            var y = s(m);
            if (y && "." !== y && (p = t.replace(new RegExp("".concat(D(y), "$")), "")) !== t) return e(p, r, c, s, l, f, g);
            var b = {};
            Object.keys(f).forEach(function (e) {
              b[f[e]] = e;
            });

            for (var w = Object.keys(b).sort().reverse(), S = w.length, O = 0; O < S; O++) {
              var x = w[O],
                  N = b[x];

              if ((p = t.replace(x, "")) !== t) {
                var B = void 0;

                switch (N) {
                  case "thousand":
                    B = Math.pow(10, 3);
                    break;

                  case "million":
                    B = Math.pow(10, 6);
                    break;

                  case "billion":
                    B = Math.pow(10, 9);
                    break;

                  case "trillion":
                    B = Math.pow(10, 12);
                }

                return e(p, r, c, s, l, f, g) * B;
              }
            }
          }
        }(function (e, t, r) {
          var n = 2 < arguments.length && void 0 !== r ? r : "",
              i = e.replace(n, "");
          return i = (i = i.replace(new RegExp("([0-9])".concat(D(t.thousands), "([0-9])"), "g"), "$1$2")).replace(t.decimal, ".");
        }(e, t, u), t, u, c, s, l, f);
      }

      e.exports = {
        unformat: function unformat(e, t) {
          var r,
              n,
              i,
              a = g("./globalState"),
              o = a.currentDelimiters(),
              u = a.currentCurrency().symbol,
              c = a.currentOrdinal(),
              s = a.getZeroFormat(),
              l = a.currentAbbreviations(),
              f = void 0;
          if ("string" == typeof e) f = function (e, t) {
            if (e.indexOf(":") && ":" !== t.thousands) {
              var r = e.split(":");

              if (3 === r.length) {
                var n = +r[0],
                    i = +r[1],
                    a = +r[2];
                return !isNaN(n) && !isNaN(i) && !isNaN(a);
              }
            }
          }(e, o) ? (r = e.split(":"), n = +r[0], i = +r[1], +r[2] + 60 * i + 3600 * n) : p(e, o, u, c, s, l, t);else {
            if ("number" != typeof e) return;
            f = e;
          }
          if (void 0 !== f) return f;
        }
      };
    }, {
      "./globalState": 4
    }],
    10: [function (e, t, r) {
      "use strict";

      function n(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, r = new Array(e.length); t < e.length; t++) {
              r[t] = e[t];
            }

            return r;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }

      function f(e) {
        return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      var i = e("./unformatting"),
          a = /^[a-z]{2,3}(-[a-zA-Z]{4})?(-([A-Z]{2}|[0-9]{3}))?$/,
          g = {
        output: {
          type: "string",
          validValues: ["currency", "percent", "byte", "time", "ordinal", "number"]
        },
        base: {
          type: "string",
          validValues: ["decimal", "binary", "general"],
          restriction: function restriction(e, t) {
            return "byte" === t.output;
          },
          message: "`base` must be provided only when the output is `byte`",
          mandatory: function mandatory(e) {
            return "byte" === e.output;
          }
        },
        characteristic: {
          type: "number",
          restriction: function restriction(e) {
            return 0 <= e;
          },
          message: "value must be positive"
        },
        prefix: "string",
        postfix: "string",
        forceAverage: {
          type: "string",
          validValues: ["trillion", "billion", "million", "thousand"]
        },
        average: "boolean",
        currencyPosition: {
          type: "string",
          validValues: ["prefix", "infix", "postfix"]
        },
        currencySymbol: "string",
        totalLength: {
          type: "number",
          restrictions: [{
            restriction: function restriction(e) {
              return 0 <= e;
            },
            message: "value must be positive"
          }, {
            restriction: function restriction(e, t) {
              return !t.exponential;
            },
            message: "`totalLength` is incompatible with `exponential`"
          }]
        },
        mantissa: {
          type: "number",
          restriction: function restriction(e) {
            return 0 <= e;
          },
          message: "value must be positive"
        },
        optionalMantissa: "boolean",
        trimMantissa: "boolean",
        roundingFunction: "function",
        optionalCharacteristic: "boolean",
        thousandSeparated: "boolean",
        spaceSeparated: "boolean",
        spaceSeparatedCurrency: "boolean",
        abbreviations: {
          type: "object",
          children: {
            thousand: "string",
            million: "string",
            billion: "string",
            trillion: "string"
          }
        },
        negative: {
          type: "string",
          validValues: ["sign", "parenthesis"]
        },
        forceSign: "boolean",
        exponential: {
          type: "boolean"
        },
        prefixSymbol: {
          type: "boolean",
          restriction: function restriction(e, t) {
            return "percent" === t.output;
          },
          message: "`prefixSymbol` can be provided only when the output is `percent`"
        }
      },
          o = {
        languageTag: {
          type: "string",
          mandatory: !0,
          restriction: function restriction(e) {
            return e.match(a);
          },
          message: "the language tag must follow the BCP 47 specification (see https://tools.ieft.org/html/bcp47)"
        },
        delimiters: {
          type: "object",
          children: {
            thousands: "string",
            decimal: "string",
            thousandsSize: "number"
          },
          mandatory: !0
        },
        abbreviations: {
          type: "object",
          children: {
            thousand: {
              type: "string",
              mandatory: !0
            },
            million: {
              type: "string",
              mandatory: !0
            },
            billion: {
              type: "string",
              mandatory: !0
            },
            trillion: {
              type: "string",
              mandatory: !0
            }
          },
          mandatory: !0
        },
        spaceSeparated: "boolean",
        spaceSeparatedCurrency: "boolean",
        ordinal: {
          type: "function",
          mandatory: !0
        },
        bytes: {
          type: "object",
          children: {
            binarySuffixes: "object",
            decimalSuffixes: "object"
          }
        },
        currency: {
          type: "object",
          children: {
            symbol: "string",
            position: "string",
            code: "string"
          },
          mandatory: !0
        },
        defaults: "format",
        ordinalFormat: "format",
        byteFormat: "format",
        percentageFormat: "format",
        currencyFormat: "format",
        timeDefaults: "format",
        formats: {
          type: "object",
          children: {
            fourDigits: {
              type: "format",
              mandatory: !0
            },
            fullWithTwoDecimals: {
              type: "format",
              mandatory: !0
            },
            fullWithTwoDecimalsNoCurrency: {
              type: "format",
              mandatory: !0
            },
            fullWithNoDecimals: {
              type: "format",
              mandatory: !0
            }
          }
        }
      };

      function u(e) {
        return !!i.unformat(e);
      }

      function p(c, s, l, e) {
        var t = 3 < arguments.length && void 0 !== e && e,
            r = Object.keys(c).map(function (e) {
          if (!s[e]) return console.error("".concat(l, " Invalid key: ").concat(e)), !1;
          var t = c[e],
              r = s[e];

          if ("string" == typeof r && (r = {
            type: r
          }), "format" === r.type) {
            if (!p(t, g, "[Validate ".concat(e, "]"), !0)) return !1;
          } else if (f(t) !== r.type) return console.error("".concat(l, " ").concat(e, ' type mismatched: "').concat(r.type, '" expected, "').concat(f(t), '" provided')), !1;

          if (r.restrictions && r.restrictions.length) for (var n = r.restrictions.length, i = 0; i < n; i++) {
            var a = r.restrictions[i],
                o = a.restriction,
                u = a.message;
            if (!o(t, c)) return console.error("".concat(l, " ").concat(e, " invalid value: ").concat(u)), !1;
          }
          if (r.restriction && !r.restriction(t, c)) return console.error("".concat(l, " ").concat(e, " invalid value: ").concat(r.message)), !1;
          if (r.validValues && -1 === r.validValues.indexOf(t)) return console.error("".concat(l, " ").concat(e, " invalid value: must be among ").concat(JSON.stringify(r.validValues), ', "').concat(t, '" provided')), !1;
          if (r.children && !p(t, r.children, "[Validate ".concat(e, "]"))) return !1;
          return !0;
        });
        return t || r.push.apply(r, n(Object.keys(s).map(function (e) {
          var t = s[e];

          if ("string" == typeof t && (t = {
            type: t
          }), t.mandatory) {
            var r = t.mandatory;
            if ("function" == typeof r && (r = r(c)), r && void 0 === c[e]) return console.error("".concat(l, ' Missing mandatory key "').concat(e, '"')), !1;
          }

          return !0;
        }))), r.reduce(function (e, t) {
          return e && t;
        }, !0);
      }

      function c(e) {
        return p(e, g, "[Validate format]");
      }

      t.exports = {
        validate: function validate(e, t) {
          var r = u(e),
              n = c(t);
          return r && n;
        },
        validateFormat: c,
        validateInput: u,
        validateLanguage: function validateLanguage(e) {
          return p(e, o, "[Validate language]");
        }
      };
    }, {
      "./unformatting": 9
    }]
  }, {}, [7])(7);
});